import React from "react";

import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';

export const TrashButton = (props) => {
	return <Button color="secondary" style={{ margin: "2vh", minWidth: "10vw" }} startIcon={<DeleteIcon />} {...props}>Cancella</Button>;
}